type InstallStepsProps = { steps: string[] };

export default function InstallSteps({ steps }: InstallStepsProps) {
  return (
    <ol className="install-steps">
      {steps.map((step, index) => (
        <li key={step}><span>{index + 1}</span><p>{step}</p></li>
      ))}
    </ol>
  );
}
